// kendo UI frontend clientside javascripts
require("@progress/kendo-ui/js/kendo.timezones.js")
require("@progress/kendo-ui/js/kendo.aspnetmvc.js")
require("@progress/kendo-ui/js/kendo.all.js")

// kendo UI cultures 
require("@progress/kendo-ui/js/cultures/kendo.culture.en-US.js")
require("@progress/kendo-ui/js/cultures/kendo.culture.nl-NL.js")
require("@progress/kendo-ui/js/cultures/kendo.culture.de-DE.js")

// License
require("./telerik-license");

// JSZip - must be loaded after Kendo UI; Kendo resolves it from window.JSZip at export time
window.JSZip = require('jszip');

// Moment 
window.moment = require('moment');